export default class responseFromDss {
    constructor (data) {
      if (data.reply) {
        this.errorMsg = data.reply.RetData.ErrorMsg
        this.objectId = data.reply.ObjectId
        this.data = data.reply.RetData
        this.value = data.reply.RetVal
        this.success = this.value === 1
      } else {
        this.success = false
      }
    }
  
    getFirstValue () {
      let keys = Object.keys(this.data).filter((i) => i !== 'datatype')
  
      if (keys.length > 0) {
        let value = this.data[keys[0]]
  
        if (value.datatype === 'sheet') {
          delete value.datatype
  
          return value
        }
  
        return value
      }
  
      return null
    }
  
    getValue (key) {
      if (this.data[key]) {
        if (this.data[key].datatype === 'table') {
            delete this.data[key].datatype
  
            return this.data[key]
        } else {
            return this.data[key].value
        }
      }
  
      return null
    }
  }
  